'use strict';

var SELECTOR = '[data-second-unit-promotion]';

/**
 * Replaces the percentage token in a localized message.
 * @param {string} template - Localized message with a {0} token
 * @param {number} percentage - Discount percentage returned by the server
 * @returns {string} localized message
 */
function replacePercentage(template, percentage) {
    return (template || '').replace('{0}', percentage);
}

/**
 * Closes the promotion information layer.
 * @param {jQuery} $component - Promotion component
 * @param {boolean} restoreFocus - Whether focus should return to the trigger
 */
function closeInfo($component, restoreFocus) {
    var $layer = $component.find('[data-second-unit-promotion-layer]');
    var $trigger = $component.find('[data-second-unit-promotion-trigger]');

    if ($layer.prop('hidden')) {
        return;
    }

    $layer.prop('hidden', true);
    $trigger.attr('aria-expanded', 'false');
    $('body').removeClass('second-unit-promotion-open');

    if (restoreFocus) {
        $trigger.trigger('focus');
    }
}

/**
 * Opens the promotion information layer.
 * @param {jQuery} $component - Promotion component
 */
function openInfo($component) {
    var $layer = $component.find('[data-second-unit-promotion-layer]');
    var $trigger = $component.find('[data-second-unit-promotion-trigger]');

    $(SELECTOR).each(function () {
        closeInfo($(this), false);
    });

    $layer.prop('hidden', false);
    $trigger.attr('aria-expanded', 'true');
    $('body').addClass('second-unit-promotion-open');
    $layer.find('.second-unit-promotion__info').trigger('focus');
}

/**
 * Replaces the PDP online-price label for eligible products.
 * @param {jQuery} $component - Promotion component
 * @param {boolean} isEligible - Whether the selected SKU participates
 */
function updatePriceLabel($component, isEligible) {
    if (!isEligible) {
        return;
    }

    var priceLabel = $component.data('price-label');
    var $label = $component.closest('.product-detail')
        .find('#pdpPrices .internet-price > .font')
        .first();

    if ($label.length && priceLabel) {
        $label.text(priceLabel);
    }
}

/**
 * Refreshes the component after a variation response.
 * @param {Object} product - Product model returned by Product-Variation
 * @param {jQuery} $container - Current product container
 */
function updateComponent(product, $container) {
    var $component = $container.find(SELECTOR);

    if (!$component.length) {
        $component = $(SELECTOR).first();
    }

    if (!$component.length) {
        return;
    }

    var promotionPrice = product ? product.secondUnitPromotionPrice : null;
    var isEligible = !!promotionPrice;

    closeInfo($component, false);
    $component.toggleClass('d-none', !isEligible);

    if (!isEligible) {
        return;
    }

    $component.find('[data-second-unit-promotion-value]').text(promotionPrice.formatted);
    $component.find('[data-second-unit-promotion-title]').text(
        replacePercentage($component.data('title-template'), promotionPrice.discountPercentage)
    );
    $component.find('[data-second-unit-promotion-description]').text(
        replacePercentage($component.data('description-template'), promotionPrice.discountPercentage)
    );
    updatePriceLabel($component, true);
}

/**
 * Binds promotion disclosure and variation events.
 */
function bindEvents() {
    $(document).on('click', '[data-second-unit-promotion-trigger]', function () {
        var $component = $(this).closest(SELECTOR);

        if ($(this).attr('aria-expanded') === 'true') {
            closeInfo($component, true);
        } else {
            openInfo($component);
        }
    });

    $(document).on('click', '[data-second-unit-promotion-close]', function () {
        closeInfo($(this).closest(SELECTOR), true);
    });

    $(document).on('click', function (event) {
        if ($(event.target).closest(SELECTOR).length) {
            return;
        }

        $(SELECTOR).each(function () {
            closeInfo($(this), false);
        });
    });

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape' || event.keyCode === 27) {
            $(SELECTOR).each(function () {
                closeInfo($(this), true);
            });
        }
    });

    $('body').on('product:afterAttributeSelect', function (event, response) {
        updateComponent(response.data.product, response.container);
    });
}

/**
 * Initializes the PDP second-unit promotion component.
 */
function init() {
    bindEvents();

    $(SELECTOR).each(function () {
        updatePriceLabel($(this), !$(this).hasClass('d-none'));
    });
}

module.exports = {
    init: init
};
